import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'

export const patientMedicalSupplyAccessQueries = {
  forList: (patientId: PatientIdType) =>
    localResultQueryOptions({
      query: db
        .selectFrom('patientMedicalSupplyAccess')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .orderBy('activeFrom', 'desc'),
    }),
}
